module.exports = __webpack_public_path__ + "static/media/buxton-15.d224ca25.jpg";